import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { User } from './useUser.interface';
import fetchUser from './useUser.request';

export default function useUser(userId: number, options?: Omit<UseQueryOptions<User>, 'queryKey'>) {
    return useQuery<User>({
        queryKey: ['user', userId],
        queryFn: () => fetchUser(userId),
        staleTime: Infinity,
        ...options,
    });
}
